import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const TriangleWarning = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} viewBox="0 0 20 20">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.833008 17.5003H19.1663L9.99967 1.66699L0.833008 17.5003ZM10.833 15.0003H9.16634V13.3337H10.833V15.0003ZM10.833 11.667H9.16634V8.33366H10.833V11.667Z"
      />
    </SvgIcon>
  );
};

export default TriangleWarning;
